var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{staticClass:"bottom-navigation",attrs:{"value":_vm.value,"color":"#000000"}},[_c('v-btn',{attrs:{"icon":"","to":"/inicio"}},[_c('span',[_vm._v("Início")]),_c('v-icon',[_vm._v("mdi-home")])],1),_c('v-btn',{attrs:{"icon":"","to":"/meta"}},[_c('span',[_vm._v("Metas")]),_c('v-icon',[_vm._v("mdi-compass")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }